import PropTypes from "prop-types"
import {
  Box,
  Typography,
  Grid,
  Container,
  useMediaQuery,
} from "@material-ui/core"
import React from "react"
import { useTheme } from "@material-ui/core/styles"
import useStyles from "./styles"

const BillingPageLayout = ({
  leftHeader,
  leftContent,
  rightHeader,
  rightHeaderButtons = null,
  rightSubtitle = null,
  rightContent,
  hideRightSide = false,
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const smallScreen = useMediaQuery(theme.breakpoints.down("sm"))

  return (
    // // a parent (Container below) with overflow: hidden needed to work around documented negative margins issue on MUI Grid container 4.4.3
    <Container
      maxWidth={hideRightSide ? "lg" : "xl"}
      style={{ overflowY: "auto" }}
    >
      <Grid container spacing={smallScreen ? 3 : 6} className={classes.root}>
        <Grid
          data-cy="billing-layout-left"
          item
          xs={12}
          md={hideRightSide ? 12 : 8}
          className={classes.gridItem}
        >
          <Typography variant="h1" className={classes.headerText}>
            {leftHeader}
          </Typography>{" "}
          {/* Implementation of mobile breadcrumbs to work around the layout scroll issue */}
          {/* <Grid style={{ overflowX: "scroll" }}>
            <Breadcrumbs />
          </Grid> */}
          <Box className={classes.contentBox}>{leftContent}</Box>
        </Grid>
        <Grid
          data-cy="billing-layout-right"
          item
          xs={12}
          md={4}
          className={classes.gridItem}
          style={
            hideRightSide
              ? {
                  display: "none",
                }
              : null
          }
        >
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
          >
            <Typography variant="h2" className={classes.headerText}>
              {rightHeader}
            </Typography>
            {rightHeaderButtons && (
              <Box display="flex" alignItems="center">
                {rightHeaderButtons}
              </Box>
            )}
          </Box>
          {rightSubtitle && (
            <Typography variant="subtitle1" className={classes.subtitleText}>
              {rightSubtitle}
            </Typography>
          )}
          <Box className={classes.contentBox}>{rightContent}</Box>
        </Grid>
      </Grid>
    </Container>
  )
}

BillingPageLayout.propTypes = {
  leftHeader: PropTypes.string,
  leftContent: PropTypes.node,
  rightHeader: PropTypes.string,
  rightHeaderButtons: PropTypes.node,
  rightSubtitle: PropTypes.string,
  rightContent: PropTypes.node,
  hideRightSide: PropTypes.bool,
}

export default BillingPageLayout
